<template>
    <modal-template>
        <div slot="header">
            {{ trans('clients.transfer_course.headline.user_list') }}
        </div>

        <div slot="body">
            <section class="section">
                <div class="assignable-users">
                    <v-client-table
                        :data="userList"
                        :columns="columns"
                        :options="options"
                        ref="table"
                    >
                        <div
                            @click="addUser(props.row.id)"
                            slot="addUser"
                            slot-scope="props"
                            class="btn btn--tertiary"
                        >
                            {{ trans('clients.transfer_course.action.add') }}
                        </div>
                    </v-client-table>
                </div>
            </section>
        </div>

        <div slot="footer">
            <button
                type="button"
                @click="$emit('close')"
                class="btn btn--primary"
            >
                {{ trans('buttons.ok') }}
            </button>
        </div>
    </modal-template>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: ['userList'],

    data() {
        return {
            tableUserList: this.userList,
            columns: ['fullname', 'username', 'email', 'addUser'],
            options: {
                filterByColumn: true,
                headings: {
                    fullname: this.trans(
                        'clients.transfer_course.label.fullname'
                    ),
                    username: this.trans(
                        'clients.transfer_course.label.username'
                    ),
                    email: this.trans('clients.transfer_course.label.email'),
                    addUser: '',
                },
                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.noResults'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },
                filterable: ['fullname', 'username', 'email'],
                sortable: [],
            },
        };
    },

    methods: {
        addUser(id) {
            this.$delete(
                this.tableUserList,
                this.tableUserList.findIndex(u => u.id == id)
            );
            EventBus.$emit('user-selected', id);
        },
    },
};
</script>
